export default "__VITE_ASSET__ee56fa62__"